import { addNamespace } from '@/app/shared/utils/NamespaceHelper'

export const NAMESPACE = 'workspaces'
const INTERNAL_NAMESPACE = NAMESPACE + '/'

const _types = {
  getters: {
  },
  actions: {
  },
  mutations: {
  }
}

export const Types = addNamespace(INTERNAL_NAMESPACE, _types)

const Index = {
  namespaced: true,
  state: {
    workspace: null
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/workspaces/store/Index.js